import { Preferences } from '../../profile/objects/preferences';
import { Column } from '../objects/column';
import { LICENCE_HISTORY_DEFAULT_COLUMNS, LICENCE_HISTORY_MODULE } from '../constant/licenceHistoryConstant';

export const setLicenceHistoryPreference = (
    new_preferences: Preferences[],
    state_columns: Column[]
): { order_by: string; order: 'asc' | 'desc'; columns: Column[]; preferences: Preferences[] } => {
    const field_names: string[] = [];
    const columns: Column[] = [];
    const preferences: Preferences[] = [];
    let order_by = 'created_date';
    let order: 'asc' | 'desc' = 'desc';

    new_preferences.forEach((preference) => {
        if (preference.module === LICENCE_HISTORY_MODULE && !field_names.includes(preference.field_name)) {
            const defaults = LICENCE_HISTORY_DEFAULT_COLUMNS.find(c => c.field_name === preference.field_name);
            if (defaults) {
                columns.push({ ...defaults, checked: preference.active, last_updated: false });
                if (preference.ordering_asc !== null) {
                    order_by = defaults.order_by || order_by;
                    order = preference.ordering_asc ? 'asc' : 'desc';
                }
            }
            preferences.push(preference);
            field_names.push(preference.field_name);
        }
    });

    if (columns.length !== state_columns.length) {
        state_columns.forEach(column => {
            if (!columns.some(c => c.field_name === column.field_name)) {
                columns.push({ ...column });
            }
        });
    }

    return { order_by, order, columns, preferences };
};
